import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _noop from 'lodash-es/noop';
import Modal from 'sushiweb/Modal/Modal';
import { P } from 'sushiweb/Typography/Text';
import Button from 'sushiweb/Button/Button';
import CheckCircleFill from 'sushiweb/Icons/all/CheckCircleFill';
import ExclamationCircle from 'sushiweb/Icons/all/ExclamationCircle';
import green from 'sushiweb/tokens/color/green';
import H5 from 'sushiweb/Typography/Heading/H5';
import red from 'sushiweb/tokens/color/red';
import Cross from 'sushiweb/Icons/all/Cross';

const ModalContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 500px;
  h5 {
    font-weight: 500;
    margin-top: 2.8rem;
  }
  p {
    color: var(--COOL-GREY-COOL-GREY500, #9197a6);
    text-align: center;
    font-family: Lexend-300;
    font-size: 16px;
    font-style: normal;
    margin: 1rem 0 2.4rem;
  }
`;

const CrossWrapper = styled.div`
  position: absolute;
  top: -7em;
  right: -5em;
  padding: 12px;
  cursor: pointer;
`;

const MessageContainer = styled.div`
  width: 324px;
`;

const denyBtnStyle = {
  background: red.z50,
  color: red.z500,
  fontWeight: 500,
  borderRadius: '10px',
};

const accepttBtnStyle = {
  fontWeight: 500,
  borderRadius: '10px',
};

const ConfirmDeactivate = ({
  title,
  message,
  isVisible,
  closeModal,
  buttonLabel,
  denyButtonLabel,
  onContinueClick,
  warning,
  loading,
}) => {
  return (
    <Modal
      visible={isVisible}
      isCentered
      padding='5.4rem 4rem'
      onClose={closeModal}
      showCloseIcon={isVisible}
    >
      <ModalContainer>
        <CrossWrapper onClick={closeModal}>
          <Cross size='2.5rem' />
        </CrossWrapper>
        {warning ? (
          <ExclamationCircle color={red.z500} size='8rem' />
        ) : (
          <CheckCircleFill color={green.z500} size='8rem' />
        )}
        <H5>{title}</H5>
        <MessageContainer>
          <P>{message}</P>
        </MessageContainer>
        <div
          style={{
            display: 'flex',
            width: '324px',
            justifyContent: 'space-between',
          }}
        >
          {denyButtonLabel !== '' && (
            <Button style={denyBtnStyle} onClick={() => closeModal()}>
              {denyButtonLabel}
            </Button>
          )}
          <Button
            style={accepttBtnStyle}
            loading={loading}
            onClick={onContinueClick}
          >
            {buttonLabel}
          </Button>
        </div>
      </ModalContainer>
    </Modal>
  );
};

ConfirmDeactivate.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  isVisible: PropTypes.bool,
  closeModal: PropTypes.func,
  buttonLabel: PropTypes.string,
  denyButtonLabel: PropTypes.string,
  onContinueClick: PropTypes.func,
  warning: PropTypes.bool,
  loading: PropTypes.bool,
};

ConfirmDeactivate.defaultProps = {
  title: '',
  message: '',
  isVisible: false,
  closeModal: _noop,
  buttonLabel: '',
  denyButtonLabel: '',
  onContinueClick: _noop,
  warning: false,
  loading: false,
};

export default ConfirmDeactivate;
